// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__2PoZu","rotation":"SmallLoader_rotation__EtgNO"};